import React, { Fragment, useState, useEffect } from 'react';

// Imgs
import microsoftTeams_logo from '../util/imgs/microsoftTeams_logo.webp';
import coderpad_logo from '../util/imgs/coderpad_logo.webp';
import hackerrank_logo from '../util/imgs/hackerrank_logo.webp';
import chime_logo from '../util/imgs/chime_logo.webp';
import zoom_logo from '../util/imgs/zoom_logo.webp';
import codesignal_logo from '../util/imgs/codesignal_logo.webp';

const Proof = () =>  {
    
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffect(() => {
        
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

	return (
	  <Fragment>
        {/* Section 1 */}
        <div style={{paddingTop: `${isMobile ? '3rem' : '3rem'}`, paddingBottom: `${isMobile ? '0' : '3rem'}`, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
            <div style={{textAlign: 'center', marginBottom: '3rem'}}>
                <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3rem'}`, color: '#fff', fontWeight: 'bold', marginTop: '.5rem', marginBottom: '.5rem'}}>
                    Works on Everything
                </h2>
                <p style={{color: 'rgb(153,153,153)', lineHeight: '2rem', fontSize: '1.125rem'}}>
                    Invisible to all screen-recording softwares.
                </p>
            </div>
            <div style={{paddingLeft: '1rem', paddingRight: '1rem', maxWidth: '64rem', width: '100%'}}>
                <div style={{display: 'grid', gap: '2rem', gridTemplateColumns: `${isMobile ? 'repeat(2,minmax(0,1fr))' : 'repeat(3,minmax(0,1fr))'}`, boxSizing: 'border-box'}}>
                    <div className='card_hover' style={{borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1.5rem'}}>
                        <img className='img_filter_white' alt="Zoom" loading="lazy" width="128" height="128" decoding="async" src={zoom_logo} style={{objectFit: 'contain', maxWidth: '100%', height: 'auto'}} />
                    </div>
                    <div className='card_hover' style={{borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1.5rem'}}>
                        <img  className='img_filter_white' alt="Hackerrank" loading="lazy" width="128" height="128" decoding="async" src={hackerrank_logo} style={{objectFit: 'contain', maxWidth: '100%', height: 'auto'}} />
                    </div>
                    <div className='card_hover' style={{borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1.5rem'}}>
                        <img  className='img_filter_white' alt="Codesignal" loading="lazy" width="128" height="128" decoding="async" src={codesignal_logo} style={{objectFit: 'contain', maxWidth: '100%', height: 'auto'}} />
                    </div>
                    <div className='card_hover' style={{borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1.5rem'}}>
                        <img  className='img_filter_white' alt="CoderPad" loading="lazy" width="128" height="128" decoding="async" src={coderpad_logo} style={{objectFit: 'contain', maxWidth: '100%', height: 'auto'}} />
                    </div>
                    <div className='card_hover' style={{borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1.5rem'}}>
                        <img  className='img_filter_white' alt="Chime" loading="lazy" width="128" height="128" decoding="async" src={chime_logo} style={{objectFit: 'contain', maxWidth: '100%', height: 'auto'}} />
                    </div>
                    <div className='card_hover' style={{borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1.5rem'}}>
                        <img  className='img_filter_white' alt="Microsoft Teams" loading="lazy" width="128" height="128" decoding="async" src={microsoftTeams_logo} style={{objectFit: 'contain', maxWidth: '100%', height: 'auto'}} />
                    </div>
                </div>
                <p style={{color: 'rgb(107, 114, 128)', fontSize: '.875rem', textAlign: 'center', paddingLeft: '1rem', paddingRight: '1rem', marginTop: '2rem'}}>
                    Undetectability may not work with some versions of MacOS. See our <a href='#' style={{textDecoration: 'underline', color: 'inherit'}}>notice</a> for more details.
                </p>
            </div>
        </div>

        {/* Section 2 */}
        {/* <div id="proof" style={{paddingLeft: '2rem', paddingRight: '2rem', maxWidth: '48rem', marginLeft: 'auto', marginRight: 'auto', boxSizing: 'border-box'}}>
            <div style={{textAlign: 'center', marginBottom: '2rem'}}>
                <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3rem'}`, fontWeight: 'bold', marginBottom: '1rem'}}>
                    Proof
                </h2>
                <p style={{fontSize: '1.125rem', lineHeight: '1.75rem', color: 'rgb(153,153,153)', fontWeight: 500}}>
                    Watch me get an offer from Amazon using Interview Cheater. Throughout this whole video, you'll see me use Interview Cheater for both the OA and the final round.
                </p>
            </div>
            <div style={{borderRadius: '.75rem', overflow: 'hidden', width: '100%', height: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <img src="https://i.ytimg.com/vi/fMk1BOptVUs/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLCHc_Eyigc_2ASimKcLtrl5lRelXQ" style={{width: '100%'}} />
            </div>
        </div> */}
	  </Fragment>
	);
  }
  
  export default Proof;
  